import { Component } from '@angular/core';

/**
 * The parent component for the events section of the UI. This includes both
 * event configuration and managing individual events.
 */
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent {}
